export enum NoonReportTypeEnum {
    Sea = 1,
    Port = 2,
    Arrival = 4,
    Departure = 5,
}

export enum NoonReportSectionEnum {
    MetaData = 0,
    General = 1,
    Activities = 2,
    Bridge = 3,
    Weather = 4,
    TankCleaning = 5,
    CargoTemperatureControl = 6,
    Engines = 7,
    FreshWater = 8,
    PowerPacks = 9,
    InertGasProduction = 10,
    Comments = 11,
    Mrv = 12,
    FuelRob = 13,
}

export enum SectionRoleEnum {
    Captain = 1,
    ChiefOfficer = 2,
    ChiefEngineer = 3,
    SecondOfficer = 4,
    ThirdOfficer = 5,
    NavigationOfficer = 6,
    DutyOfficer = 7,
    SecondEngineer = 8,
    DutyEngineer = 9,
    PumpMan = 10,
}

export enum MrvDataTypeEnum {
    Unknown = 0,
    BetweenEospAndBerthArrival = 1,
    BetweenBerthDepartureAndSosp = 2,
}

export enum FuelRobDataTypeEnum {
    EstimationAtNoon = 1,
    MeasureAfterBunkering = 3,
}

export enum FuelTypeEnum {
    HFO,
    MGO,
}

export enum EngineDataTypeEnum {
    MainEngine = 1,
    AuxiliaryEngine = 2,
    DieselGasOilDrivenPowerPack = 3,
    ElectricalDrivenPowerPack = 4,
    Boilers = 5,
    ShaftGenerator = 6,
    Incinerator = 7,
    InertGasGenerator = 8,
}

export enum DirectionEnum {
    Against = 1,
    AgainstStarboardSide = 2,
    StarboardSide = 3,
    WithStarboardSide = 4,
    With = 5,
    WithPortSide = 6,
    PortSide = 7,
    AgainstPortSide = 8,
}

export enum WindForceEnum {
    Calm = 1,
    LightAir = 2,
    GentleBreeze = 3,
    ModerateBreeze = 4,
    FreshBreeze = 5,
    StrongBreeze = 6,
    HighWindModerateGaleNearGale = 7,
    GaleFreshGale = 8,
    StrongGale = 9,
    StormWholeGale = 10,
    ViolentStorm = 11,
    HurricaneForce = 12,
}

export enum SeaStateEnum {
    CalmGlassy = 0,
    CalmRippled = 1,
    SmoothWavelets = 2,
    Slight = 3,
    Moderate = 4,
    Rough = 5,
    VeryRough = 6,
    High = 7,
    VeryHigh = 8,
    Phenomenal = 9,
}

export enum PortVisitStatusEnum {
    Planned = 1,
    Arrived = 2,
    Departed = 3,
}

export enum VesselOwnershipTypeEnum {
    Unknown = 0,
    Owned = 1,
    TimeCharter = 2,
    FinanciallyLeased = 3,
    OperationallyLeased = 4,
}

export enum BoilerTypeEnum {
    Auxiliary,
    Composite,
    Donkey,
}

export enum PumpTypeEnum {
    Electric,
    Hydraulic,
}

export enum InertGasTypeEnum {
    Nitrogen,
    InertGas,
}

export enum PropellerTypeEnum {
    Fixed,
    ControllablePitchPropeller,
}

export enum BoilerTypeEnumV3 {
    Auxiliary = 1,
    Composite = 2,
    Donkey = 3,
    Economizer = 4,
}

export enum PumpTypeEnumV3 {
    Electric,
    Hydraulic,
}

export enum CargoHeatingTypeEnum {
    Undefined = 0,
    Indirect = 1,
    HeaterOnDeck = 2,
    Direct = 3,
}

export enum InertGasTypeEnumV3 {
    Nitrogen,
    InertGas,
}

export enum PropellerTypeV3Enum {
    Fixed = 1,
    ControllablePitchPropeller = 2,
}

export enum FuelTypeEnumV3 {
    Hfo = 1,
    Mgo = 2,
}
